import { render, staticRenderFns } from "./UnauthorizedToLesson.vue?vue&type=template&id=4d26906a&"
import script from "./UnauthorizedToLesson.vue?vue&type=script&lang=js&"
export * from "./UnauthorizedToLesson.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports